import { createContext, useContext } from 'react';
import {
  BrandAffinityInsightsCoreContext,
  Timespan,
} from 'modules/intelligentInsights/brandAffinityInsights/types';
import { BrandAffinityLevel } from 'modules/domains';

export const defaultCoreContext = {
  insightsData: {
    projectId: '0',
    history: [],
    deltas: [],
    transitionMap: [],
    engagementMetrics: [],
    campaignImpacts: [],
    unscoredMetrics: [],
  },
  isLoading: false,
  isError: false,
  isReady: false,
  // biome-ignore lint/correctness/noUnusedVariables:
  fetchCoreData: (nextTimespan: Timespan) => null,
  selectedAffinityTab: BrandAffinityLevel.LOYAL,
  setSelectedAffinityTab: () => ({}),
};

export const CoreContext = createContext<BrandAffinityInsightsCoreContext>(defaultCoreContext);
export const useCoreContext = () => useContext(CoreContext);
